
import React, { useEffect, useMemo, useState } from 'react';
import { Button }from '@cmsgov/design-system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

// Components

import AttributeItems from './AttributeItems';
import AutocompleteSearch from '../../../components/common/autocomplete-search/AutocompleteSearch';

const AttributeView = props => {
    const {
        assignees,
        attributeTypes,
        attributes = [],
        changeMode,
        currentAssignee,
        lists,
        mode,
        modes,
        updateAssignees,
        updateAssigneeAttributes,
        userId,
        view,
        views
    } = props;

    const [ items, updateItems ] = useState(attributes);
    const optionListByView = lists[view] || [];
    const VIEW = {
        TAG: 'tag',
        WORKGROUP: 'workgroup'
    };

    useEffect(() => {
        updateItems(attributes);
    }, [ attributes.toString() ]);

    const deleteItem = id => {
        updateItems(items => items.filter(item => item.id !== id));
    };

    const fetchResults = (searchVal) => {
        const filterResults = optionListByView.filter(item =>
            item.name.toLowerCase().includes(searchVal.toLowerCase())
        );
        return filterResults;
    };

    const getAttributeView = () => {
        switch(mode) {
            case modes.READONLY:
                return (
                    <AttributeItems
                        { ...{
                            deleteItem,
                            items,
                            isDeletable: mode === modes.EDIT
                        } }
                    />
                );
            case modes.EDIT:
                return (
                    <div>
                        <AutocompleteSearch
                            {...{
                                id: 'manage-assignees-component-autocomplete',
                                setSelectedItems: updateItems,
                                selectedItems: items,
                                label: 'assignees.attributes.autocomplete.label',
                                formatMessageObject: { view: view === attributeTypes.TAGS ? VIEW.TAG : VIEW.WORKGROUP },
                                fetchResults,
                                isClearInputValue: true,
                                debounceSearchTime: 500,
                                isClearApiResults: true
                            }}
                        />
                        <AttributeItems
                            { ...{
                                deleteItem,
                                items,
                                isDeletable: mode === modes.EDIT
                            } }
                        />
                    </div>
                );
        }
    };

    const handleCancel = () => {
        changeMode({ [ view ]: modes.READONLY });
        updateItems(attributes);
    };

    const handleSaveChanges = () => {
        const payload = {
            userId,
            ...Object.keys(views).reduce((attributes , attribute) => {
                return attribute === view ?
                    {
                        ...attributes,
                        [ attribute ]: items.map(a => a.id)
                    } :
                    {
                        ...attributes,
                        [ attribute ]: currentAssignee[attribute].map(a => a.id)
                    };
            }, { })
        };

        updateAssigneeAttributes(payload, undefined) // param GET for a while for port 8888. Remove after development
            .then(updatedAssignee => {
                if(updatedAssignee) {
                    const {
                        updatedUserInfo,
                        updatedUserId
                    } = updatedAssignee;
                    const updatedAssignees = assignees.reduce((assignees, assignee) => {
                        return assignee.id === updatedUserId ?
                            [
                                ...assignees,
                                updatedUserInfo
                            ] :
                            [
                                ...assignees,
                                assignee
                            ];
                    }, [  ]);
                    updateAssignees(updatedAssignees);
                    changeMode({ [ view ]: modes.READONLY });
                }
            });
    };

    const isDisabled = useMemo(
        () => Object.values(views).some(v => v === modes.EDIT),
        [ views ]
    );

    return (
        <div>
            <hr/>
            <div className = 'grid-row margin-bottom-2em'>
                <div className = 'desktop:grid-col-6 text-capitalize'>
                    <h3>
                        <FormattedMessage id = { `assignees.attributes.header.${ view }` } />
                    </h3>
                </div>
                <div className = 'desktop:grid-col-6 text-right'>
                    {
                        mode === modes.READONLY ?

                            <Button
                                className = 'usa-button gi-button gi-button__secondary'
                                disabled = { isDisabled }
                                onClick = { () => changeMode({ [ view ]: modes.EDIT }) }
                            >
                                <FontAwesomeIcon icon = 'edit'/> &nbsp;
                                <FormattedMessage id = 'button.edit'/>
                            </Button> :
                            <span className = 'controls'>
                                <Button
                                    className = 'usa-button gi-button gi-button__secondary'
                                    onClick = { handleCancel }
                                >
                                    <FormattedMessage id = 'button.cancel'/>
                                </Button>
                                <Button
                                    className = 'usa-button gi-button gi-button__primary'
                                    onClick = { handleSaveChanges }
                                >
                                    <FormattedMessage id = 'button.save_changes'/>
                                </Button>
                            </span>
                    }
                </div>
            </div>
            { getAttributeView() }
        </div>
    );
};

export default AttributeView;